// ABOUTME: Auth support feature exports
// ABOUTME: Provides session token management and logout utilities for admin/support access

import authSupport from "@/model/auth/authSupport"

export default authSupport
export { authSupport }
export { logoutUser } from "./fnLogout"
